export default __webpack_public_path__ + "static/EMR-0fc6d9eba4c81866569d865841c6c369.png";